// extracted by mini-css-extract-plugin
export default {"newssection":"NewsSection_newssection__XGtbR","newssection__header":"NewsSection_newssection__header__O6EgZ"};